var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSecurityServices(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_446_1459",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 1,
    width: 53,
    height: 58
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 1H56V58.0973H3V1Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_446_1459)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.2493 22.1715L26.3848 40.3703C25.6971 41.1591 24.5007 41.2411 23.7118 40.5534L16.9787 34.6787C16.1919 33.9903 16.1079 32.7932 16.7977 32.0043L17.7064 30.9607C18.3947 30.1732 19.5905 30.0913 20.3794 30.7797L24.6418 34.499L38.3523 18.7709C39.04 17.9833 40.2344 17.9014 41.0253 18.5877L42.0662 19.4971C42.8537 20.1855 42.937 21.3826 42.2493 22.1715ZM54.2478 14.222C49.836 12.7723 45.601 10.9412 41.7357 8.82991C37.8684 6.71657 34.3687 4.32444 31.4238 1.75471H31.4224C30.8875 1.29005 30.1964 1.07872 29.5225 1.14893C28.8472 1.07872 28.156 1.29005 27.6232 1.75471H27.6211C24.6749 4.32444 21.1751 6.71657 17.3099 8.82991C13.4425 10.9412 9.20758 12.7723 4.79711 14.222C3.72254 14.5758 3.01764 15.6002 3.0734 16.7291V16.7601C3.47748 25.0985 5.98663 33.271 10.3324 40.3943C12.5056 43.9609 15.1208 47.2341 18.0932 50.1384C21.0691 53.0461 24.405 55.5808 28.0163 57.6679C28.4796 57.935 29.0069 58.0445 29.5225 57.9922C30.036 58.0445 30.5654 57.935 31.0286 57.6679C34.642 55.5808 37.9765 53.0461 40.9503 50.1384C43.9241 47.2341 46.5414 43.9609 48.7125 40.3943C53.0569 33.271 55.5674 25.0985 55.9715 16.7601V16.7291C56.0273 15.6002 55.3224 14.5758 54.2478 14.222Z",
    fill: "url(#paint0_linear_446_1459)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_446_1459",
    x1: 29.5225,
    y1: 1.13574,
    x2: 29.5225,
    y2: 58.0049,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#342E6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#51539D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurityServices);
export default __webpack_public_path__ + "static/media/SecurityServices.405d7886658ec61c70ebc3e8b886a337.svg";
export { ForwardRef as ReactComponent };